import React from "react";
import { Tooltip } from "antd";
import ChangePassword from "../changePassword";

const AgentTable = ({
  agents,
  passwordChange,
  agentStatus,
  changeSelfieStatus,
  changeAllSelfieStatus,
}) => {
  return (
    <div className="card all-cards mt-10 p-0">
      <div className="card-header bg-white py-6">
        <h5 className="mb-0">Agents List</h5>
      </div>

      <div className="card-body table-responsive p-4">
        <table
          className="table table-hover align-middle mb-0 table-bordered"
          id="commontable"
        >
          <thead className="theadheading">
            <tr>
              <th>Sr.No.</th>
              <th>Name</th>
              <th>Employee ID</th>
              <th>Mobile</th>
              <th>Status</th>

              {passwordChange && <th className="w-15">Action</th>}
              
              {/* <th>
                <div className="d-flex">
                  Selfie Status{" "}
                  <Tooltip title="Change Selfie Status all" placement="top">
                    <label className="checkbox agents-checkbox ml-2">
                      <input
                        type="checkbox"
                        name="Checkboxes1"
                        checked={
                          agents?.length > 0 &&
                          agents.every((agent) => agent.selfieMode)
                        }
                        onChange={(e) =>
                          changeAllSelfieStatus(e.target.checked)
                        }
                      />
                      <span></span>
                    </label>
                  </Tooltip>
                </div>
              </th> */}
            
            
            </tr>
          </thead>

          <tbody>
            {agents?.length > 0 ? (
              agents.map((agent, index) => {
                const employeeId = agent?.employeeId;
                const mobile = agent?.mobile;

                return (
                  <React.Fragment key={employeeId || index}>
                    <tr>
                      <td>{index + 1}</td>

                      <td>{agent?.name}</td>

                      <td>{employeeId}</td>

                      <td>{mobile}</td>

                      <td>
                        {agent?.active ? (
                          <span className="badge btn-primary">Active</span>
                        ) : (
                          <span className="badge btn-danger text-white">
                            Inactive
                          </span>
                        )}
                      </td>

                      {passwordChange && (
                        <td>
                          <div className="d-flex align-items-center">
                            <Tooltip title="Change Password" placement="top">
                              <span
                                className="mr-3"
                                data-toggle="modal"
                                data-target={`#changePasswordModal${employeeId}`}
                              >
                                <i className="fas fa-unlock-alt text-success icon-lg cursor-pointer"></i>
                              </span>
                            </Tooltip>
                            <Tooltip
                              title={
                                agent?.active
                                  ? "agent active"
                                  : "agent inactive"
                              }
                              placement="top"
                            >
                              <span className="switch custom-toogle-switch switch-sm">
                                <label className="checkbox checkbox-sm">
                                  <input
                                    type="checkbox"
                                    checked={agent?.active}
                                    onChange={() => agentStatus(agent?.mobile)}
                                  />
                                  <span></span>
                                </label>
                              </span>
                            </Tooltip>
                          </div>
                        </td>
                      )}

                      {/* <td>
                        <div className="d-flex align-items-center">
                          <Tooltip
                            title={
                              agent?.selfieMode
                                ? "Selfie Mode On"
                                : "Selfie Mode Off"
                            }
                            placement="top"
                          >
                            <span className="switch custom-toogle-switch switch-sm">
                              <label className="checkbox checkbox-sm">
                                <input
                                  type="checkbox"
                                  checked={agent?.selfieMode}
                                  onChange={() =>
                                    changeSelfieStatus(agent?.mobile)
                                  }
                                />
                                <span></span>
                              </label>
                            </span>
                          </Tooltip>
                        </div>
                      </td> */}
                   
                    </tr>

                    <ChangePassword employeeId={employeeId} mobile={mobile} />
                  </React.Fragment>
                );
              })
            ) : (
              <tr>
                <td
                  colSpan={passwordChange ? 6 : 5}
                  className="text-center py-5"
                >
                  No Agents Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AgentTable;
